export function selectDropdownOption(state, payload) {
  return {
    ...state,
    currentChapter: setDrodownValueInCurrentChapter(
      state.currentChapter,
      payload
    ),
  };
}

function setDrodownValueInCurrentChapter(currentChapter, payload) {
  return {
    ...currentChapter,
    components: setDrodownValueInComponents(currentChapter.components, payload),
  };
}

function setDrodownValueInComponents(components, payload) {
  return components.map((component) => {
    if (component.id === payload.componentID) {
      component = setDropdownValueInDDQComponent(component, payload);
    }
    return component;
  });
}

function setDropdownValueInDDQComponent(ddqComponent, payload) {
  const setDropdownValueInAnswerSteps = (step) => {
    const updatedStep = { ...step };
    if (updatedStep.value === payload.name) {
      updatedStep.droppedId = payload.value;
      updatedStep.showFeedback = false;
    }
    return updatedStep;
  };
  return {
    ...ddqComponent,
    answerSteps: ddqComponent.answerSteps.map(setDropdownValueInAnswerSteps),
  };
}
